import React, {ReactElement} from "react";
import imagePathFromFile from "../utils/imagePathFromFile";
import {AiOutlineCaretRight} from "react-icons/ai";
import {MediaCenterBox} from "@varymadellc/my-weed-club-component-library";
import ImageModal from "./ImageModal";
import Modal from "../layout/Modal";
import ProfileCard from "@/components/ProfileCard";
import cx from "classnames";

const GalleryTitle = ({title, description, className}): ReactElement => {
    return (
        <div
            className={cx("relative flex flex-row items-center justify-center h-full w-full bg-secondary text-black p-2", className)}>
            <div className="flex flex-col items-center justify-center">
                <h2 className="text-xl font-bold break-all">{title}</h2>
                <hr className="w-48 m-2 border-primary"/>
                {
                    description && <p className="text-sm break-all">{description}</p>
                }
            </div>
            <div className="w-16">
                <AiOutlineCaretRight className="h-[200px] w-[60px]"/>
            </div>
        </div>
    );
};

const GalleryItem = ({file, files, index}): ReactElement => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const filePath = imagePathFromFile(file);

    return (
        <MediaCenterBox className="max-w-full max-h-full w-full h-full">
            <>
                <img onClick={() => setIsModalOpen(!isModalOpen)} className="max-w-full max-h-full" src={filePath}
                     alt={file?.fileName || ''}/>
                <Modal
                    isOpen={isModalOpen}
                    preventScroll={true}
                    onClose={() => setIsModalOpen(false)}
                >
                    <MediaCenterBox>
                        <ImageModal getImageCallback={(file) => imagePathFromFile(file)} images={files}
                                    selectedImageIndex={index} setIsOpen={setIsModalOpen}/>
                    </MediaCenterBox>
                </Modal>
            </>
        </MediaCenterBox>
    );
};

export const covertGalleryToList = (gallery, username?: string, showTitleCard: boolean = true) => {
    const items: ReactElement[] = [];

    if (gallery?.name && showTitleCard) {
        items.push(
            <ProfileCard onClick={
                () => {
                    if (!username || !gallery?.uuid) return;

                    return window.location.href = `/u/${username}/galleries/${gallery.uuid}`;
                }
            } className="h-full" noPadding={true} title="Gallery">
                <GalleryTitle className="h-full" description={gallery?.description} title={gallery?.name}/>
            </ProfileCard>
        );
    }

    if (gallery?.files && gallery?.files?.length > 0) {
        gallery.files.forEach((file, index) => {
            items.push(<GalleryItem index={index} file={file} files={gallery.files}/>);
        });
    }

    return items;
}

export default function getGalleryList(galleries, username?: string) {
    if (!galleries || galleries.length === 0 || !Array.isArray(galleries)) {
        return [];
    }

    return galleries.map((gallery) => covertGalleryToList(gallery, username));
}